import React, { createContext, useContext, useMemo } from 'react';
import { useUbicacionesUsuario, type UbicacionesUsuarioState } from '../hooks/useUbicacionesUsuario';

type UbicacionesUsuarioContextValue = UbicacionesUsuarioState;

const UbicacionesUsuarioContext = createContext<UbicacionesUsuarioContextValue | null>(null);

export const UbicacionesUsuarioProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const value = useUbicacionesUsuario();
  const memo = useMemo(() => value, [
    value.ubicaciones,
    value.preferida,
    value.preferidaNro,
    value.preferidaUbicacion,
    value.loading,
    value.error,
    value.sinAsignaciones,
    value.esAdmin,
    value.refresh,
  ]);
  return (
    <UbicacionesUsuarioContext.Provider value={memo}>
      {children}
    </UbicacionesUsuarioContext.Provider>
  );
};

const defaultContextValue: UbicacionesUsuarioContextValue = {
  ubicaciones: [],
  preferida: null,
  preferidaNro: null,
  preferidaUbicacion: null,
  loading: false,
  error: null,
  sinAsignaciones: false,
  esAdmin: true,
  refresh: async () => {},
};

export function useUbicacionesUsuarioContext(): UbicacionesUsuarioContextValue {
  const ctx = useContext(UbicacionesUsuarioContext);
  return ctx ?? defaultContextValue;
}

export function useOperacionesUbicacionBloqueadas(): boolean {
  const { sinAsignaciones, esAdmin, loading } = useUbicacionesUsuarioContext();
  return !loading && sinAsignaciones && !esAdmin;
}

export function usePreferidaUbicacion() {
  const { preferidaUbicacion } = useUbicacionesUsuarioContext();
  return preferidaUbicacion;
}
